import { render } from "./Desktop.vue?vue&type=template&id=e8d05588&scoped=true&ts=true"
import script from "./Desktop.vue?vue&type=script&lang=ts"
export * from "./Desktop.vue?vue&type=script&lang=ts"

import "./Desktop.vue?vue&type=style&index=0&id=e8d05588&lang=scss&scoped=true"

import exportComponent from "/Users/suhwanlim/Projects/pr/MoTobi-Web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8d05588"]])

export default __exports__